export enum ImportPriceField {
    PURCHASE_PRICE = 'purchasePrice',
    PRICE_YIELD = 'priceYield',
    PRICE = 'price',
    PRICE_VAT = 'priceVat'
}

// Cabeceras de la plantilla de actualización de precios (compartidas entre la descarga y la importación).
// Al normalizarse (sin espacios ni acentos) coinciden con las de las plantillas CSV anteriores (CodigoInterno, PrecioIVA, etc.)
export const ProductPricesTemplateColumn = {
    SUPPLIER_CODE: 'Código Interno',
    PRODUCT: 'Producto',
    // Solo informativa, para filtrar por proveedor; el importador no la lee
    SUPPLIER: 'Proveedor',
    [ImportPriceField.PURCHASE_PRICE]: 'Precio Compra',
    [ImportPriceField.PRICE_YIELD]: 'Rentabilidad',
    [ImportPriceField.PRICE]: 'Precio',
    [ImportPriceField.PRICE_VAT]: 'Precio IVA'
}

export enum ImportCustomerTypeField {
    PRICE = 'price',
    PRICE_VAT = 'priceVat'
}

export const CUSTOMER_TYPE_PRICE_LABEL: Record<ImportCustomerTypeField, string> = {
    [ImportCustomerTypeField.PRICE]: 'de Venta s/IVA',
    [ImportCustomerTypeField.PRICE_VAT]: 'de Venta c/IVA'
}
